var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader5ShapeB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1919.72 730.14l.41-.14q-.6-359.46-.13-718.94V0H0v395.88c0 33.48-9.66 73.48 3.28 105.2C183.92 411 384.82 429.79 570.4 495.9c175.52 62.52 337.12 159.58 512.46 222.59 269.53 96.85 565.26 105.18 836.86 11.65z",
    fill: "#d7dcea",
    opacity: 0.3
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZDdkY2VhO29wYWNpdHk6MC4zO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOTE5LjcyLDczMC4xNGwuNDEtLjE0cS0uNi0zNTkuNDYtLjEzLTcxOC45NFYwSDBWMzk1Ljg4YzAsMzMuNDgtOS42Niw3My40OCwzLjI4LDEwNS4yQzE4My45Miw0MTEsMzg0LjgyLDQyOS43OSw1NzAuNCw0OTUuOWMxNzUuNTIsNjIuNTIsMzM3LjEyLDE1OS41OCw1MTIuNDYsMjIyLjU5QzEzNTIuMzksODE1LjM0LDE2NDguMTIsODIzLjY3LDE5MTkuNzIsNzMwLjE0WiIvPjwvc3ZnPg==";
export { SvgHeader5ShapeB as ReactComponent };